var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/wallet"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wallet"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.368 18.4271L16.5346 32.3605C10.7346 34.8605 6.66797 40.6271 6.66797 47.3271V37.5605C6.66797 28.0938 13.4013 20.1938 22.368 18.4271Z",
    stroke: "#2065B1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M71.7286 37.5588V47.3255C71.7286 39.9922 66.862 33.7588 60.1953 31.7588C61.9286 27.4255 62.4286 24.0255 61.5953 21.1922C61.5286 20.8922 61.4286 20.5922 61.2953 20.3255C67.4953 23.5255 71.7286 30.0922 71.7286 37.5588Z",
    stroke: "#2065B1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M42.2018 8.39381L42.1018 8.62714L32.4352 31.0605H22.9352C20.6685 31.0605 18.5018 31.5271 16.5352 32.3605L22.3685 18.4271L22.5018 18.0938L22.7352 17.5605C22.8018 17.3605 22.8685 17.1605 22.9685 16.9938C27.3352 6.89381 32.2685 4.59381 42.2018 8.39381Z",
    stroke: "#FDB913",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M60.1669 31.7271C58.6669 31.2604 57.0669 31.0604 55.4669 31.0604H32.4336L42.1003 8.62707L42.2003 8.39374C42.7003 8.5604 43.1669 8.79374 43.6669 8.99374L51.0336 12.0937C55.1336 13.7937 58.0003 15.5604 59.7336 17.6937C60.0669 18.0937 60.3336 18.4604 60.5669 18.8937C60.8669 19.3604 61.1003 19.8271 61.2336 20.3271C61.3669 20.6271 61.4669 20.9271 61.5336 21.1937C62.4336 23.9937 61.9003 27.4271 60.1669 31.7271Z",
    stroke: "#FDB913",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M71.7404 47.3279V53.8279C71.7404 54.4946 71.707 55.1612 71.6737 55.8279C71.0404 67.4612 64.5404 73.3279 52.207 73.3279H26.207C25.407 73.3279 24.607 73.2612 23.8404 73.1612C13.2404 72.4612 7.5737 66.7946 6.8737 56.1946C6.7737 55.4279 6.70703 54.6279 6.70703 53.8279V47.3279C6.70703 40.6279 10.7737 34.8612 16.5737 32.3612C18.5737 31.5279 20.707 31.0612 22.9737 31.0612H55.507C57.1404 31.0612 58.7404 31.2946 60.207 31.7279C66.8404 33.7612 71.7404 39.9612 71.7404 47.3279Z",
    stroke: "#2065B1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletGift);
export default __webpack_public_path__ + "static/media/wallet-gift.edc42a3b50d827cf86e4ef349e51deac.svg";
export { ForwardRef as ReactComponent };